// extracted by mini-css-extract-plugin
module.exports = {"otpContainer":"otp_otpContainer__RpNWJ","header_inner_alert":"otp_header_inner_alert__16Z7a"};